const ALL_COMPANY = 'ALL_COMPANY';

export function getAllCompany(data) {
  return dispatch => {
    dispatch({
      type: ALL_COMPANY,
      data: [...data],
    });
  };
}

export function allCompany(state = {}, action) {
  switch (action.type) {
    case ALL_COMPANY:
      return action.data;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/finance/budget/all_company.js